import React from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

export default function ManageJobsFilterSection({
  icon,
  title,
  count,
  expanded,
  onToggle,
  children,
}) {
  return (
    <div className="mj-fd-section">
      <button className="mj-fd-section-header" onClick={onToggle}>
        <div className="mj-fd-section-left">
          {icon}
          <span className="mj-fd-section-title">{title}</span>
          {count > 0 && <span className="mj-fd-section-order">{count}</span>}
        </div>
        {expanded ? (
          <UpOutlined className="mj-fd-chevron" />
        ) : (
          <DownOutlined className="mj-fd-chevron" />
        )}
      </button>

      {expanded ? <div className="mj-fd-section-body">{children}</div> : null}
    </div>
  );
}
